
import "bootstrap/dist/css/bootstrap.min.css";

function Clientdashboard() {
  return (
    <div className="container min-vh-100 d-flex justify-content-center align-items-center">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "1100px" }}>
        <h1 className="text-center mb-4">Welcome, Partner!</h1>

        <div className="row g-4">
          {/* Add Product Section */}
          <div className="col-md-6">
            <div className="card p-4 bg-light">
              <h2 className="mb-3">How to Add a Product</h2>
              <p>Follow these steps to add your products to the shopping platform:</p>
              <ol className="list-group list-group-numbered">
                <li className="list-group-item">Navigate to the " Product Management" section in the menu.</li>
                <li className="list-group-item">Enter the product details such as name, price, description, and category.</li>
                <li className="list-group-item">Upload high-quality images of the product.</li>
                <li className="list-group-item">Specify stock availability and any discount offers.</li>
                <li className="list-group-item">Click on the "Submit" button to list your product.</li>
                <li className="list-group-item">Insert only portrait images for your product.</li>
              </ol>
            </div>
          </div>

          {/* Policy & Malpractice Section */}
          <div className="col-md-6">
            <div className="card p-4 bg-danger text-white">
              <h2 className="mb-3">Important Guidelines & Policies</h2>
              <ul className="list-group list-group-flush">
                <li className="list-group-item bg-danger text-white">Ensure all product details are accurate and comply with platform policies.</li>
                <li className="list-group-item bg-danger text-white">Any form of malpractice, including misleading descriptions or fake listings, will result in immediate account suspension.</li>
                <li className="list-group-item bg-danger text-white">Repeated violations will lead to permanent account blocking.</li>
                <li className="list-group-item bg-danger text-white">Keep your contact information up to date for better customer communication.</li>
                <li className="list-group-item bg-danger text-white">Maintain a high standard of service to build trust with customers.</li>
                <li className="list-group-item bg-danger text-white">Failure to fulfill orders promptly may lead to penalties.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clientdashboard;
